import React from 'react'
import Logo2 from '../../oocl3.png'
export default class Header extends React.Component {
  constructor () {
    super()
    this.state = {
      userName: 'username'
    }
  }

  render () {
    return (
      <header className='gbcr-main-grid-child' style={{ verticalAlign: 'middle' }}>
        <h1>
          <img style={{ marginLeft: 70 }} src={Logo2} width='100px' />
          <p>Cargo Release</p>
        </h1>
      </header>
    )
  }
}
